import { createFileRoute } from '@tanstack/react-router';
import { TelegramPage } from '../../../features/B2a/telegram-page';

/** #/whatsapp/telegram — the Telegram bot (D-140): connect, status, webhook, groups, limits. Lane B2a. */
export const Route = createFileRoute('/_app/whatsapp/telegram')({
  component: TelegramPage,
});
